import { useTranslation } from "react-i18next";
import { FC } from "react";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";

const ProductSummary: FC<{ d?: ProductDetailResponse }> = ({ d }) => {
  const { t } = useTranslation();

  if (d?.productType !== "TOUR") return null;
  const f = (name: ProdAttrNameTourInfo) =>
    ProdAttrUtils.TOUR.getDpValue(d?.attributeList ?? [], name);
  const summary = [
    { title: t("Duration"), value: f("DURATION"), icon: "duration" },
    { title: t("Tour Type"), value: d.categoryName, icon: "tour-type" },
    { title: t("Group Size"), value: f("GROUP_SIZE"), icon: "group-size" },
    { title: t("Languages"), value: f("LANGUAGE"), icon: "language" },
  ];
  return (
    <div className="pd-left grid grid-cols-2 justify-between sm:flex">
      {summary.map((item, index) => (
        <div
          key={index}
          className="mb-[1.5rem] flex items-center gap-[0.75rem]"
        >
          <div className="h-12 w-12 content-center rounded-[0.625rem] border border-[#DEDEDE]">
            <img
              className="mx-auto h-[1.375rem] w-[1.375rem]"
              src={`../../assets/icons/${item.icon}.svg`}
              alt={item.icon}
            />
          </div>
          <p className="text-base font-semibold leading-[1.625rem] text-[#232323]">
            {item.title}
            <br />
            <span className="text-[0.875rem] font-normal leading-[1.375rem] text-[#5E6D77]">
                {item.title === t("Duration")
                ? `${item.value.slice(0, -1)}${t(item.value.slice(-1))}`
                : t(item.value)}
            </span>
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProductSummary;
